<template>
    <div>
        <div class="load load-white load-200" v-if="!showContent"></div>
        
        <!-- ERROR RESTRICTED -->
        <div class="box-error" v-if="showContent && errorsPost.country_pep">
            <h3 class="title-secondary">{{ getMyLanguage("box-error", "title-error") }}</h3>
            <p v-if="newRegister.person.pep" v-html='getMyLanguage("box-error","not_allowed_restricted_country_pep-pep")'></p>
            <p v-if="!newRegister.person.pep" v-html='getMyLanguage("box-error","not_allowed_restricted_country_pep-country")'></p>
            <!-- <div class="cod-error">
                Cód.: {{errorsGet.dataInvite}}
            </div> -->
        </div>

        
        <!-- BOX REGISTRATION -->
        <!-- <div class="box-registration" v-if="showContent && !errorsPost.newRegister" :class="{dropListOpened: (dropListOpened.languageCompany || dropListOpened.countryCompany || dropListOpened.ddiCompany || dropListOpened.languagePerson || dropListOpened.countryPerson || dropListOpened.ddiPerson)}"> -->
        <div class="box-registration" v-if="showContent" :class="{dropListOpened: (dropListOpened.languageCompany || dropListOpened.countryCompany || dropListOpened.ddiCompany || dropListOpened.languagePerson || dropListOpened.countryPerson || dropListOpened.ddiPerson)}">
            <h2 class="title-secondary">{{ getMyLanguage("register","register.title") }}</h2>

            <div class="formBox">
                <div class="check-type-code">
                    <div class="form-group-radio">
                        <input type="radio" id="typeSingular" :value="true" name="radioFlowTypeCode" class="form-radio" @click='flow.typeCode = "account_type_person"' checked >
                        <label for="typeSingular" class="form-radio-label">
                            <span>{{ getMyLanguage("register","register.type-code.singular") }}</span>
                        </label>

                        <input type="radio" id="typeCollective" :value="false" name="radioFlowTypeCode" class="form-radio" @click='flow.typeCode = "account_type_company"' >
                        <label for="typeCollective" class="form-radio-label">
                            <span>{{ getMyLanguage("register","register.type-code.collective") }}</span>
                        </label>
                    </div>
                </div>

                <!-- INVITE COMPANY -->
                <div class="invite-company" v-if='flow.typeCode === "account_type_company"'>
                    <div class="anc anc-company" id="!company"></div>

                    <h3>{{getMyLanguage("purchase-token","purchase-token.content.box-register.subtitle.companyData")}}</h3>
                    <label class="formFullName">
                        <span class="ph">{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.companyName")}}</span>
                        <input v-model="newRegister.company.fullName" type="text" class="form" :class='{error: errorForm.companyInvite.fullName}' @keydown="errorForm.companyInvite.fullName = false" maxlength="255" autocomplete="off" >
                    </label>
                    <p class="msg-validate-form msg-error anime" v-if='errorForm.companyInvite.fullName'>{{getMyLanguage("errors","errors.nameError")}}</p>
                    

                    <!-- EMAIL COMPANY -->
                    <label class="formYourEmail">
                        <span class="ph">{{getMyLanguage("purchase-token","purchase-token.content.box-register.placeholder.companyEmail")}}</span>
                        <input v-model="validateEmail.company.val" onpaste="return false;" @blur='regexEmail("company")' @keyup='checkEmail("company")' type="email" class="form formYourEmail" :class='{error: (errorForm.companyInvite.email || errorsPost.newRegister === "account_activate_email_already_exists" || validateEmail.company.regex === false)}' @keydown="errorForm.companyInvite.email = false" maxlength="60" autocomplete="off">
                    </label>
                    <p class="msg-validate-form msg-error anime" :class="{invalidated: validateEmail.company.regex}" v-if='validateEmail.company.regex === false || errorForm.companyInvite.email'>{{getMyLanguage("errors","errors.emailError")}}</p>
                    
                    <label class="formYourEmail">
                        <span class="ph">{{getMyLanguage("client-space","client-space.account.lbl.repeatEmail")}}</span>
                        <input v-model="newRegister.company.email" onpaste="return false;" @keyup='checkEmail("company")' type="email" id="email" class="form formYourEmail" :class='{error: (errorForm.companyInvite.email || errorsPost.newRegister === "account_activate_email_already_exists"), warning: validateEmail.company.status === false}' maxlength="60" autocomplete="off">
                    </label>
                    <p class="msg-validate-form msg-warning anime" :class="{validated: validateEmail.company.status, invalidated: validateEmail.company.status}" v-if='validateEmail.company.status === false'>{{getMyLanguage("errors","errors.emailRepeatError")}}</p>
                    <p class="msg-validate-form msg-warning anime" :class="{validated: validateEmail.company.status, invalidated: validateEmail.company.status}" v-if='errorsPost.newRegister === "account_activate_email_already_exists"'>{{getMyLanguage("errors","errors.emailRegistered")}}</p>

                    <!-- LANGUAGE COMPANY -->
                    <div class="autocomplete formLanguage" :class="{opened: dropListOpened.languageCompany}">
                        <div class="openAutocomplete" v-if="!listLanguagesCompanyStatus" @click="dropListLanguagesCompany(true)"></div>
                        <div class="closeAutocomplete closeDropListCountry" v-if="listLanguagesCompanyStatus" v-on:click="dropListLanguagesCompany(false)"></div>

                        <label>
                            <span class="ph">{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.language")}}</span>
                            <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedLanguageCompanyFlag}/flags`" class="flag-selected" v-if="selectedLanguageCompanyFlag != false">
                            <input type="text" id="languageCompanyID" class="form" :class="{selected: selectedLanguageCompanyFlag != false, error: errorForm.companyInvite.languageId}" @focus="dropListLanguagesCompany(true)" v-on:keyup="filterListLanguageCompany" @blur="dropListLanguagesCompany(false)" @keydown.esc="dropListLanguagesCompany(false)" :value="languagesList(selectedLanguageCompany.code)" :title='getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.language")' autocomplete="off">
                        </label>
                        <p class="msg-validate-form msg-error anime" v-if='errorForm.companyInvite.languageId'>{{getMyLanguage("errors","errors.language")}}</p>

                        <ul id="drop-list-company" v-if="listLanguagesCompanyStatus">
                            <li v-for="(itemList,index) in langsTranslated" :key="index" v-on:click="(newRegister.company.languageId = itemList.id),(selectedLanguageCompany.code = itemList.code),(selectedLanguageCompanyFlag = itemList.flag), (dropListLanguagesCompany(false)), errorForm.companyInvite.languageId = false">
                                <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${itemList.flag}/flags`">
                                <a>{{ languagesList(itemList.code) }}</a>
                            </li>
                        </ul>
                    </div>

                    <!-- COUNTRY COMPANY -->
                    <div class="autocomplete formResidenceCountry" :class="{opened: dropListOpened.countryCompany}">
                        <div class="openAutocomplete" v-if="!listCountryCompanyStatus" @click="dropListCountryCompany(true)"></div>
                        <div class="closeAutocomplete closeDropListCountry" v-if="listCountryCompanyStatus" v-on:click="dropListCountryCompany(false)"></div>

                        <label>
                            <span class="ph">{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.companyCountry")}}</span>
                            <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedCountryFlagCompany}/flags`" class="flag-selected" v-if="selectedCountryFlagCompany != false">
                            <input type="text" id="residenceCompanyCountry" class="form" :class="{selected: selectedCountryFlagCompany != false, error: errorForm.companyInvite.countryId}" @focus="dropListCountryCompany(true)" @blur="dropListCountryCompany(false)" @keydown.esc="dropListCountryCompany(false)" v-on:keyup="filterListCountryCompany" :value="countryTranslate(selectedCountryCompany.IsoCode)" :title='getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.residence")' autocomplete="off">
                        </label>
                        <p class="msg-validate-form msg-error anime" v-if='errorForm.companyInvite.countryId'>{{getMyLanguage("errors","errors.residenceError")}}</p>

                        <ul id="drop-list" v-if="listCountryCompanyStatus">
                            <li v-for="(itemListCompany,index) in countriesTranslated" :key="index" v-on:click="(newRegister.company.countryId = itemListCompany.Id), (newRegister.company.phoneCountryId = itemListCompany.Id), (this.changeMaskCompany()), (selectedCountryFlagCompany = itemListCompany.Flag), (selectedCountryDDICompany.countrySelected = true), (selectedCountryDDICompany.active = 'active'), (selectedCountryDDICompany.phoneMask = itemListCompany.PhoneMask), (selectedCountryDDICompany.ddi = itemListCompany.DDI), (selectedCountryDDICompany.flag = itemListCompany.Flag), (selectedCountryCompany.IsoCode = itemListCompany.IsoCode), (dropListCountryCompany(false)), errorForm.companyInvite.countryId = false">
                                <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${itemListCompany.Flag}/flags`">
                                <a>{{ countryTranslate(itemListCompany.IsoCode)}}</a>
                            </li>
                        </ul>
                    </div>

                    <!-- PHONE COMPANY -->
                    <div class="formPhone" :class='{opened: dropListOpened.ddiCompany, active: selectedCountryDDICompany.active, error: (errorsPost.newRegister === "account_activate_phone_already_exists" || errorForm.companyInvite.phoneNumber)}'>
                        <label>
                            <span class="ph">{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.companyPhone")}}</span>
                        </label>

                        <div class="d-flex">
                            <div class="select-ddi" id="selectDDICompany" v-if="selectedCountryDDICompany.countrySelected && selectedCountryDDICompany.changeMask">
                                <div class="open-select-ddi" @click="dropListDDICompany(true)"></div>
                                <div class="close-select-ddi" v-if="selectedCountryDDICompany.openSelect" @click="dropListDDICompany(false)"></div>
                                <div class="selected-ddi">
                                    <div class="flag">
                                        <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedCountryDDICompany.flag}/flags`" v-if="selectedCountryDDICompany.flag != ''">
                                    </div>
                                    <span class="ddi">+{{selectedCountryDDICompany.ddi}}</span>
                                </div>
                                <ul class="list-ddi" v-if="selectedCountryDDICompany.openSelect">
                                    <div class="scroll">
                                        <li v-for="(ddiList,index) in countriesTranslated" :key="index" @click='(newRegister.company.phoneCountryId = ddiList.Id), (selectedCountryDDICompany.phoneMask = ddiList.PhoneMask), (this.changeMaskCompany()), (selectedCountryDDICompany.ddi = ddiList.DDI), (selectedCountryDDICompany.flag = ddiList.Flag), (dropListDDICompany(false)), (newRegister.company.phoneNumber = "")'>
                                            <div class="flag">
                                                <img class="anime" :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${ddiList.Flag}/flags`">
                                            </div>
                                            <span class="name-country">{{ countryTranslate(ddiList.IsoCode) }}</span>
                                            <span class="ddi" >(+{{ddiList.DDI}})</span>
                                        </li>
                                    </div>
                                </ul>
                            </div>

                            <label v-if="selectedCountryDDICompany.changeMask">
                                <input v-model="validatePhone.company.val" id="phoneNumberCompany" type="text" class="form" v-mask="selectedCountryDDICompany.phoneMask" @keydown="errorForm.companyInvite.phoneNumber = false" @blur='regexPhone("company"), selectedCountryDDICompany.openSelect = false' maxlength="25" autocomplete="off" >
                            </label>
                        </div>

                        <div class="form load-phone" v-if="!selectedCountryDDICompany.changeMask"></div>
                    </div>
                    <p class="msg-validate-form msg-error anime" v-if='validatePhone.company.regex === false || errorForm.companyInvite.phoneNumber'>{{getMyLanguage("errors","errors.phoneError")}}</p>
                    <p class="msg-validate-form msg-error anime" v-if='errorsPost.newRegister === "account_activate_phone_already_exists"'>{{getMyLanguage("errors","errors.phoneRegistered")}}</p>

                    <label class="formTaxNumber">
                        <span class="ph">{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.companyTaxNumber")}}</span>
                        <input v-model="newRegister.company.taxNumber" type="text" class="form" :class="{error: errorForm.companyInvite.taxNumber}" @keydown="errorForm.companyInvite.taxNumber = false" maxlength="80" autocomplete="off" >
                    </label>
                    <p class="msg-validate-form msg-error anime" v-if='errorForm.companyInvite.taxNumber'>{{getMyLanguage("errors","errors.taxNumber")}}</p>


                    <!-- ERRORS COMPANY -->
                    <!-- <div class="msgError errorsCompany">
                        <span class="nameError">{{ getMyLanguage("errors", "errors.nameError") }}</span>
                        <span class="emailError">{{ getMyLanguage("errors", "errors.emailError") }}</span>
                        <span class="residenceError">{{ getMyLanguage("errors", "errors.residenceError") }}</span>
                        <span class="phoneError">{{ getMyLanguage("errors", "errors.phoneError") }}</span>
                        <span class="taxNumberError">{{ getMyLanguage("errors", "errors.taxNumber") }}</span>
                        <span class="email_existe" v-if='errorsPost.newRegister === "account_activate_email_already_exists"'>{{ getMyLanguage("box-error", "account_activate_email_already_exists")}}</span>
                        <span class="phone_existe" v-if='errorsPost.newRegister === "account_activate_phone_already_exists"'>{{ getMyLanguage("box-error", "account_activate_phone_already_exists")}}</span>
                    </div> -->
                </div>


                <!-- INVITE PERSON -->
                <div class="invite-person">
                    <div class="anc anc-company" id="!person"></div>

                    <h3 v-if='flow.typeCode === "account_type_company"'>{{getMyLanguage("purchase-token","purchase-token.content.box-register.subtitle.partnerData")}}</h3>

                    <div class="check-pep">
                        <p>{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.check-pep")}}</p>

                        <div class="form-group-radio">
                            <input type="radio" v-model="newRegister.person.pep" id="pepTrue" :value="true" name="radioPEP" class="form-radio" @click='newRegister.person.pep = true' :checked='newRegister.person.pep' >
                            <label for="pepTrue" class="form-radio-label">
                                <span>{{getMyLanguage("client-space","client-space.account.modal.btn-yes")}}</span>
                            </label>

                            <input type="radio" v-model="newRegister.person.pep" id="pepFalse" :value="false" name="radioPEP" class="form-radio" @click="newRegister.person.pep = false" :checked='!newRegister.person.pep' >
                            <label for="pepFalse" class="form-radio-label">
                                <span>{{getMyLanguage("client-space","client-space.account.modal.btn-no")}}</span>
                            </label>
                        </div>

                        <p class="alert" v-if="newRegister.person.pep">{{getMyLanguage("purchase-token","purchase-token.content.box-register.alert.check-pep")}}</p>
                    </div>

                    <label class="formFullName">
                        <span class="ph">{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.fullname")}}</span>
                        <input v-model="newRegister.person.fullName" type="text" class="form" :class="{error: errorForm.personInvite.fullName}" @keydown="errorForm.personInvite.fullName = false" maxlength="80" autocomplete="off" >
                    </label>
                    <p class="msg-validate-form msg-error anime" v-if='errorForm.personInvite.fullName'>{{getMyLanguage("errors","errors.nameError")}}</p>


                    <!-- EMAIL -->
                    <label class="formYourEmail">
                        <span class="ph">{{getMyLanguage("client-space","client-space.account.lbl.email")}}</span>
                        <input v-model="validateEmail.person.val" onpaste="return false;" @blur='regexEmail("person")' @keyup='checkEmail("person")' @keydown="errorForm.personInvite.email = false" type="email" class="form formYourEmail" :class='{error: (errorForm.personInvite.email || errorsPost.newRegister === "account_activate_email_already_exists" || validateEmail.person.regex === false)}' maxlength="60" autocomplete="off">
                    </label>
                    <p class="msg-validate-form msg-error anime" :class="{invalidated: validateEmail.person.regex}" v-if='validateEmail.person.regex === false || errorForm.personInvite.email'>{{getMyLanguage("errors","errors.emailError")}}</p>

                    <label class="formYourEmail">
                        <span class="ph">{{getMyLanguage("client-space","client-space.account.lbl.repeatEmail")}}</span>
                        <input v-model="newRegister.person.email" onpaste="return false;" @keyup='checkEmail("person")' type="email" id="email" class="form formYourEmail" :class='{error: (errorForm.personInvite.email || errorsPost.newRegister === "account_activate_email_already_exists")}' maxlength="60" autocomplete="off">
                    </label>
                    
                    <p class="msg-validate-form msg-warning anime" :class="{validated: validateEmail.person.status, invalidated: validateEmail.person.status}" v-if='validateEmail.person.status === false'>{{getMyLanguage("errors","errors.emailRepeatError")}}</p>
                    <p class="msg-validate-form msg-warning anime" :class="{validated: validateEmail.person.status, invalidated: validateEmail.person.status}" v-if='errorsPost.newRegister === "account_activate_email_already_exists"'>{{getMyLanguage("errors","errors.emailRegistered")}}</p>


                    <!-- LANGUAGE -->
                    <div class="autocomplete formLanguage" :class="{opened: dropListOpened.languagePerson}">
                        <div class="openAutocomplete" v-if="!listLanguagesStatus" @click="dropListLanguages(true)"></div>
                        <div class="closeAutocomplete closeDropListCountry" v-if="listLanguagesStatus" v-on:click="dropListLanguages(false)"></div>

                        <label>
                            <span class="ph">{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.language")}}</span>
                            <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedLanguageFlag}/flags`" class="flag-selected" v-if="selectedLanguageFlag != false">
                            <input type="text" id="languageID" class="form" :class="{selected: selectedLanguageFlag != false, error: errorForm.personInvite.languageId}" @focus="dropListLanguages(true)" v-on:keyup="filterListLanguage" @blur="dropListLanguages(false)" @keydown.esc="dropListLanguages(false)" :value="languagesList(selectedLanguage.code)" :title='getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.language")' autocomplete="off">
                        </label>
                        <p class="msg-validate-form msg-error anime" v-if='errorForm.personInvite.languageId'>{{getMyLanguage("errors","errors.language")}}</p>

                        <ul id="drop-list" v-if="listLanguagesStatus">
                            <li v-for="(itemList,index) in langsTranslated" :key="index" v-on:click="(newRegister.person.languageId = itemList.id),(selectedLanguage.code = itemList.code),(selectedLanguageFlag = itemList.flag), (dropListLanguages(false)), errorForm.personInvite.languageId = false">
                                <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${itemList.flag}/flags`">
                                <a>{{ languagesList(itemList.code) }}</a>
                            </li>
                        </ul>
                    </div>

                    <!-- COUNTRY -->
                    <div class="autocomplete formResidenceCountry" :class="{opened: dropListOpened.countryPerson}">
                        <div class="openAutocomplete" v-if="!listCountryStatus" @click="dropListCountry(true)"></div>
                        <div class="closeAutocomplete closeDropListCountry" v-if="listCountryStatus" v-on:click="dropListCountry(false)"></div>

                        <label>
                            <span class="ph">{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.residence")}}</span>
                            <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedCountryFlag}/flags`" class="flag-selected" v-if="selectedCountryFlag != false">
                            <input type="text" id="residenceCountry" class="form" :class="{selected: selectedCountryFlag != false, error: errorForm.personInvite.countryId}" @focus="dropListCountry(true)" @blur="dropListCountry(false)" @keydown.esc="dropListCountry(false)" v-on:keyup="filterListCountry" :value="countryTranslate(selectedCountry.IsoCode)" :title='getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.residence")' autocomplete="off">
                        </label>
                        <p class="msg-validate-form msg-error anime" v-if='errorForm.personInvite.countryId'>{{getMyLanguage("errors","errors.residenceError")}}</p>

                        <ul id="drop-list" v-if="listCountryStatus">
                            <li v-for="(itemList,index) in countriesTranslated" :key="index" v-on:click="(newRegister.person.countryId = itemList.Id), (newRegister.person.phoneCountryId = itemList.Id), (this.changeMask()), (selectedCountryFlag = itemList.Flag), (selectedCountryDDI.countrySelected = true), (selectedCountryDDI.active = 'active'), (selectedCountryDDI.phoneMask = itemList.PhoneMask), (selectedCountryDDI.ddi = itemList.DDI), (selectedCountryDDI.flag = itemList.Flag), (selectedCountry.IsoCode = itemList.IsoCode), (dropListCountry(false)), errorForm.personInvite.countryId = false">
                                <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${itemList.Flag}/flags`">
                                <a>{{ countryTranslate(itemList.IsoCode)}}</a>
                            </li>
                        </ul>
                    </div>

                    <!-- PHONE -->
                    <div class="formPhone" :class='{opened: dropListOpened.ddiPerson, active: selectedCountryDDI.active, error: (errorsPost.newRegister === "account_activate_phone_already_exists" || errorForm.personInvite.phoneNumber)}'>
                        <label>
                            <span class="ph">{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.phone")}}</span>
                        </label>
                        
                        <div class="d-flex">
                            <div class="select-ddi" v-if="selectedCountryDDI.countrySelected && selectedCountryDDI.changeMask">
                                <div class="open-select-ddi" @click="dropListDDI(true)"></div>
                                <div class="close-select-ddi" v-if="selectedCountryDDI.openSelect" @click="dropListDDI(false)"></div>
                                <div class="selected-ddi">
                                    <div class="flag">
                                        <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedCountryDDI.flag}/flags`" v-if="selectedCountryDDI.flag != ''">
                                    </div>
                                    <span class="ddi">+{{selectedCountryDDI.ddi}}</span>
                                </div>
                                <ul class="list-ddi" v-if="selectedCountryDDI.openSelect">
                                    <div class="scroll">
                                        <li v-for="(ddiList,index) in countriesTranslated" :key="index" @click='(newRegister.person.phoneCountryId = ddiList.Id), (selectedCountryDDI.phoneMask = ddiList.PhoneMask), (this.changeMask()), (selectedCountryDDI.ddi = ddiList.DDI), (selectedCountryDDI.flag = ddiList.Flag), (dropListDDI(false)), (newRegister.person.phoneNumber = "")'>
                                            <div class="flag">
                                                <img class="anime" :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${ddiList.Flag}/flags`">
                                            </div>
                                            <span class="name-country">{{ countryTranslate(ddiList.IsoCode) }}</span>
                                            <span class="ddi" >(+{{ddiList.DDI}})</span>
                                        </li>
                                    </div>
                                </ul>
                            </div>

                            <label v-if="selectedCountryDDI.changeMask">
                                <input v-model="validatePhone.person.val" id="phoneNumber" type="text" class="form" v-mask="selectedCountryDDI.phoneMask" @keydown="errorForm.personInvite.phoneNumber = false" @blur='regexPhone("person")' :placeholder='this.getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.phone")' maxlength="25" autocomplete="off" >
                            </label>
                        </div>

                        <div class="form load-phone" v-if="!selectedCountryDDI.changeMask"></div>
                    </div>
                    <p class="msg-validate-form msg-error regex-error anime" v-if='validatePhone.person.regex === false || errorForm.personInvite.phoneNumber'>{{getMyLanguage("errors","errors.phoneError")}}</p>
                    <p class="msg-validate-form msg-error anime" v-if='errorsPost.newRegister === "account_activate_phone_already_exists"'>{{getMyLanguage("errors","errors.phoneRegistered")}}</p>


                    <!-- TAXNUMBER -->
                    <label class="formTaxNumber">
                        <span class="ph">{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.personTaxNumber")}}</span>
                        <input v-model="newRegister.person.taxNumber" type="text" class="form" maxlength="80" autocomplete="off" >
                    </label>
                    

                    <!-- ACCEPTS -->
                    <div class="accepts">
                        <div class="form-group-check">
                            <input type="checkbox" id="acceptTerms" class="form-check" v-model="accept.terms">
                            <label for="acceptTerms" class="form-check-label" :class="{error: errorForm.acceptsInvite.acceptTerms}"><small>{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.accept-terms") }}</small></label>
                            <a :href="`/${flagSelected}/terms-and-conditions`" target="_blank" class="lnk-terms-group-check">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.accept-terms.lnk") }}</a>
                        </div>
                        
                        <div class="form-group-check">
                            <input type="checkbox" id="acceptNotify" class="form-check" v-model="accept.notify">
                            <label for="acceptNotify" class="form-check-label" :class="{error: errorForm.acceptsInvite.acceptNotify}"><small>{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.accept-notify") }}</small></label>
                        </div>
                        
                        <div class="form-group-check">
                            <input type="checkbox" id="acceptGDPR" class="form-check" v-model="accept.gdpr">
                            <label for="acceptGDPR" class="form-check-label" :class="{error: errorForm.acceptsInvite.acceptGdpr}"><small>{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.accept-gdpr") }}</small></label>
                        </div>
                    </div>

                    <div class="box-error" v-if="errorsPost.general != false">
                        <h3 class="title-secondary">{{ getMyLanguage("box-error", "title-error") }}</h3>
                        <p>{{ getMyLanguage("box-error","general-error") }}</p>
                        <div class="cod-error">
                            Cód.: {{errorsPost.general}}
                        </div>
                    </div>

                    <div class="check-referrer" v-if="!hideBoxReferrer">
                        <p>{{getMyLanguage("purchase-token", "purchase-token.content.box-register.has-referrer")}}</p>

                        <div class="form-group-radio">
                            <input type="radio" v-model="hasReferrer" id="refTrue" :value="true" name="radioReferrer" class="form-radio" @click='hasReferrer = true' :checked='hasReferrer' >
                            <label for="refTrue" class="form-radio-label">
                                <span>{{getMyLanguage("client-space","client-space.account.modal.btn-yes")}}</span>
                            </label>

                            <input type="radio" v-model="hasReferrer" id="refFalse" :value="false" name="radioReferrer" class="form-radio" @click="hasReferrer = false" :checked='!hasReferrer' >
                            <label for="refFalse" class="form-radio-label">
                                <span>{{getMyLanguage("client-space","client-space.account.modal.btn-no")}}</span>
                            </label>
                        </div>

                        <label v-if="hasReferrer">
                            <span class="ph">{{getMyLanguage("purchase-token","purchase-token.content.box-register.placeholder.has-referrer")}}</span>
                            <input type="text" class="form" v-mask="'AAAAAAAA-AAAA-AAAA-AAAA-AAAAAAAAAAAA'" :mask="[/[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, '-', /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/]" maxlength="36" :class="{error: errorForm.codReferrerId}" @keydown="errorForm.codReferrerId = false" v-model="utm.referrerId">
                        </label>

                        <p class="msg-validate-form msg-error anime" v-if='hasReferrer && errorForm.codReferrerId'>{{getMyLanguage("errors","errors.referrer")}}</p>
                    </div>

                    <div class="your-referrer" v-if="hideBoxReferrer">
                        <p>{{getMyLanguage("purchase-token","purchase-token.content.box-register.placeholder.your-referrer")}}</p>
                        <div class="referrer">{{utm.referrerId}}</div>
                    </div>

                    <div id="btnRegister" v-if="!accept.terms || !accept.notify || !accept.gdpr" @click="validationFormInvite()" class="btn-primary btn-disabled">{{ getMyLanguage("register","register.btn-register") }}</div>
                    <div id="btnRegister" v-if="accept.terms && accept.notify && accept.gdpr && !load && !errorsPost.general" @click="validationFormInvite()" class="btn-primary">{{ getMyLanguage("register","register.btn-register") }}</div>
                    <div class="btn-primary load" v-if="load"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // const $ = require('jquery')
    // window.$ = $

    import getMyContentLanguage from "@/services/contentLanguage.js";
    import langsList from "@/services/listLanguages.js";
    import countriesList from "@/services/listCountries.js";

    import apiPlatform from '@/config/apiPlatform.js'
  
    export default {
        props: {
            dataOrigin: String
        },

        data(){
            return{
                showContent: false,
                load: false,

                errorsGet: {
                    dataInvite: false
                },
                
                errorsPost: {
                    newRegister: false,
                    country_pep: false,
                    general: false
                },

                validateEmail: {
                    company: {
                        regex: '',
                        status: '',
                        val: ''
                    },

                    person: {
                        regex: '',
                        status: '',
                        val: ''
                    }
                },
                
                validatePhone: {
                    company: {
                        regex: '',
                        status: '',
                        val: ''
                    },

                    person: {
                        regex: '',
                        status: '',
                        val: ''
                    }
                },

                flow: {
                    typeCode: "account_type_person",
                },

                dataCountry: [],
                dataLanguage: [],
                langsTranslated: [],
                
                flagSelected: "en",
                showFlag: false,
                showFlagCompany: false,

                listLanguagesStatus: false,
                selectedLanguage: {},
                selectedLanguageFlag: false,
                
                listLanguagesCompanyStatus: false,
                selectedLanguageCompany: {},
                selectedLanguageCompanyFlag: false,

                listCountryStatus: false,
                selectedCountry: {},
                selectedCountryFlag: false,
                
                listCountryCompanyStatus: false,
                selectedCountryCompany: {},
                selectedCountryFlagCompany: false,
                
                selectedCountryDDICompany: {
                    changeMask: true,
                    phoneMask: '?',
                    countrySelected: false,
                    flag: ''
                },

                selectedCountryDDI: {
                    changeMask: true,
                    phoneMask: '?',
                    countrySelected: false,
                    flag: ''
                },

                dropListOpened: {
                    languageCompany: false,
                    countryCompany: false,
                    ddiCompany: false,

                    languagePerson: false,
                    countryPerson: false,
                    ddiPerson: false
                },

                newRegister: {
                    person: {
                        pep: false,
                        fullName: "",
                        email: "",
                        countryId: "",
                        languageId: "",
                        phoneCountryId: "",
                        phoneNumber: "",
                        taxNumber: ""
                    },
                    company: {
                        pep: false,
                        fullName: "",
                        email: "",
                        countryId: "",
                        languageId: "",
                        phoneCountryId: "",
                        phoneNumber: "",
                        taxNumber: ""
                    }
                    
                    // companyInvite: {},
                    
                    // pep: false,
                    // fullName: "",
                    // email: "",
                    // languageId: "",
                    // countryId: "",
                    // phoneCountryId: "",
                    // phoneNumber: "",
                    // AccountType: "account_type_person"
                },                

                errorForm: {
                    companyInvite: {},
                    personInvite: {},
                    acceptsInvite: {
                        acceptTerms: false,
                        acceptNotify: false,
                        acceptGdpr: false
                    },

                    company: false,
                    person: false,
                    accepts: false,

                    codReferrerId: false
                },

                accept: {
                    terms: false,
                    notify: false,
                    gdpr: false
                },

                resendLoad: false,

                hideBoxReferrer: false,
                hasReferrer: false,
                
                utm: {
                    referrerId: "",
                    source: "",
                    campaign: ""
                },

                urlPost: ""
            }
        },
        
        async mounted(){
            // const urlParams = new URLSearchParams(window.location.search);
            // this.referrerId = urlParams.get('utm_content')
            
            // if ( this.referrerId || localStorage.getItem("ReferrerId") ){
            //     this.hideBoxReferrer = true
            //     localStorage.setItem("ReferrerId", this.referrerId)
            // }

            const urlParams = new URLSearchParams(window.location.search);
            if ( urlParams.size > 0 ){
                localStorage.setItem("referrerId", urlParams.get('utm_content'))
                localStorage.setItem("utmSource", urlParams.get('utm_source'))
                localStorage.setItem("utmCampaign", urlParams.get('utm_campaign'))
            }
            
            setTimeout(() => {
                if (localStorage.getItem("referrerId")){
                    this.utm.referrerId = localStorage.getItem("referrerId")
                    this.utm.source = localStorage.getItem("utmSource")
                    this.utm.campaign = localStorage.getItem("utmCampaign")

                    this.hideBoxReferrer = true
                }

                this.showInstall = sessionStorage.getItem("showInstallApp")
            }, 500);
            

            // LANGUAGE
            await apiPlatform.get('/api/v1/platform/language/dne_ecosystem')
            .then(response => {
                this.dataLanguage = response.data

                setTimeout(() => {
                    this.orderLangs()
                }, 100);
            })
            .catch(error => {
                this.errorsGet.dataInvite = error.response.data
            })
            
            
            // COUNTRY
            await apiPlatform.get('api/v1/platform/country')
            .then(response => {
                this.dataCountry = response.data

                setTimeout(() => {
                    this.ordercountries()
                }, 100);
            })
            .catch(error => {
                this.errorsGet.dataInvite = error.response.data
            })
            
            
            setTimeout(() => {
                this.showContent = true
            }, 500);
        },


        methods: {
            getMyLanguage(group, code){
                return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code)
            },

            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code

                document.title = this.getMyLanguage("register","register.title") + " | DNE Ecosystem";
                document.getElementsByTagName('meta')["description"].content = ''
            },


            // LANGUAGES
            languagesList(code){
                return langsList(code, this.$store.state.SelectLanguage.code)
            },

            orderLangs() {
                this.langsTranslated = [...this.dataLanguage];

                this.langsTranslated.forEach(lang => {
                    lang.translatedName = this.languagesList(lang.code);
                });

                this.langsTranslated.sort((a, b) => {
                    return a.translatedName.toLowerCase().localeCompare(b.translatedName.toLowerCase());
                });
            },


            // COUNTRIES
            countryTranslate(code){
                return countriesList(code, this.$store.state.SelectLanguage.code)
            },

            ordercountries() {
                this.countriesTranslated = [...this.dataCountry];

                this.countriesTranslated.forEach(lang => {
                    lang.translatedCountry = this.countryTranslate(lang.IsoCode);
                });

                this.countriesTranslated.sort((a, b) => {
                    return a.translatedCountry.toLowerCase().localeCompare(b.translatedCountry.toLowerCase());
                });
            },


            regexEmail(emailCheck){
                const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if ( emailCheck === "company"){
                    if (regex.test(this.validateEmail.company.val)) {
                        this.validateEmail.company.regex = true
                    } else{
                        this.validateEmail.company.regex = false
                    }
                } else if ( emailCheck === "person"){
                    if (regex.test(this.validateEmail.person.val)) {
                        this.validateEmail.person.regex = true
                    } else{
                        this.validateEmail.person.regex = false
                    }
                }
            },

            checkEmail(emailCheck){
                if ( emailCheck === "company" ){
                    if ( this.validateEmail.company.val === this.newRegister.company.email ){
                        this.validateEmail.company.status = true
                    } else{
                        this.validateEmail.company.status = false
                    }
                } else if ( emailCheck === "person" ){
                    if ( this.validateEmail.person.val === this.newRegister.person.email ){
                        this.validateEmail.person.status = true
                    } else{
                        this.validateEmail.person.status = false
                    }
                }
            },

            regexPhone(phoneCheck){
                const regex = /^\+[1-9]\d{8,14}$/;

                if ( phoneCheck === "company"){
                    let phoneE164Company = this.selectedCountryDDICompany.ddi + this.validatePhone.company.val
                    phoneE164Company = "+" + phoneE164Company.replace(/[^0-9]/g,'')
                    
                    if (regex.test(phoneE164Company)) {
                        this.validatePhone.company.regex = true
                    } else{
                        this.validatePhone.company.regex = false
                    }
                } else if ( phoneCheck === "person"){
                    let phoneE164Person = this.selectedCountryDDI.ddi + this.validatePhone.person.val
                    phoneE164Person = "+" + phoneE164Person.replace(/[^0-9]/g,'')
                    
                    if (regex.test(phoneE164Person)) {
                        this.validatePhone.person.regex = true
                    } else{
                        this.validatePhone.person.regex = false
                    }
                }
            },

            changeFlagLanguage(value){
                this.showFlag = false
                this.newRegister.person.languageId = value

                this.showFlag = true
            },

            changeMaskCompany(){
                this.selectedCountryDDICompany.changeMask = false

                setTimeout(() => {
                    this.selectedCountryDDICompany.changeMask = true
                }, 1000);

                setTimeout(() => {
                    document.getElementById('phoneNumberCompany').focus()
                }, 1050);
            },

            changeMask(){
                this.selectedCountryDDI.changeMask = false

                setTimeout(() => {
                    this.selectedCountryDDI.changeMask = true
                }, 1000);
                
                setTimeout(() => {
                    document.getElementById('phoneNumber').focus()
                }, 1050);
            },

            dropListCountryCompany(status){
                setTimeout(() => {
                    this.listCountryCompanyStatus = status
                }, 250)
                
                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.countryCompany = true
                        document.getElementById('residenceCompanyCountry').focus()
                    }, 10);
                } else {
                    this.dropListOpened.countryCompany = false
                }
            },
            
            dropListCountry(status){
                setTimeout(() => {
                    this.listCountryStatus = status
                }, 250)
                
                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.countryPerson = true
                        document.getElementById('residenceCountry').focus()
                    }, 10);
                } else {
                    this.dropListOpened.countryPerson = false
                }
            },
            
            dropListLanguages(status){
                setTimeout(() => {
                    this.listLanguagesStatus = status
                }, 250)

                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.languagePerson = true
                        document.getElementById('languageID').focus()
                    }, 10);
                } else {
                    this.dropListOpened.languagePerson = false
                }
            },
            
            dropListLanguagesCompany(status){
                setTimeout(() => {
                    this.listLanguagesCompanyStatus = status
                }, 250);

                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.languageCompany = true
                        document.getElementById('languageCompanyID').focus()
                    }, 10);
                } else {
                    this.dropListOpened.languageCompany = false
                }
            },
            
            dropListDDICompany(status){
                console.log("aaa")
                setTimeout(() => {
                    this.selectedCountryDDICompany.openSelect = status
                }, 250);

                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.ddiCompany = true
                    }, 10);
                } else {
                    this.dropListOpened.ddiCompany = false
                }
            },
            
            dropListDDI(status){
                setTimeout(() => {
                    this.selectedCountryDDI.openSelect = status
                }, 250);

                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.ddiPerson = true
                    }, 10);
                } else {
                    this.dropListOpened.ddiPerson = false
                }
            },

            filterListLanguageCompany() {
                var input, filter, ul, li, a, i, txtValue;
                input = document.getElementById("languageCompanyID");
                filter = input.value.toUpperCase();
                ul = document.getElementById("drop-list-company");
                li = ul.getElementsByTagName("li");
                for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByTagName("a")[0];
                txtValue = a.textContent || a.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        li[i].style.display = "";
                } else {
                        li[i].style.display = "none";
                }
                }
            },

            filterListLanguage() {
                var input, filter, ul, li, a, i, txtValue;
                input = document.getElementById("languageID");
                filter = input.value.toUpperCase();
                ul = document.getElementById("drop-list");
                li = ul.getElementsByTagName("li");
                for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByTagName("a")[0];
                txtValue = a.textContent || a.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        li[i].style.display = "";
                } else {
                        li[i].style.display = "none";
                }
                }
            },

            filterListCountryCompany() {
                var input, filter, ul, li, a, i, txtValue;
                input = document.getElementById("residenceCompanyCountry");
                filter = input.value.toUpperCase();
                ul = document.getElementById("drop-list");
                li = ul.getElementsByTagName("li");
                for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByTagName("a")[0];
                txtValue = a.textContent || a.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        li[i].style.display = "";
                } else {
                        li[i].style.display = "none";
                }
                }
            },
            
            filterListCountry() {
                var input, filter, ul, li, a, i, txtValue;
                input = document.getElementById("residenceCountry");
                filter = input.value.toUpperCase();
                ul = document.getElementById("drop-list");
                li = ul.getElementsByTagName("li");
                for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByTagName("a")[0];
                txtValue = a.textContent || a.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        li[i].style.display = "";
                } else {
                        li[i].style.display = "none";
                }
                }
            },


            validationFormInvite(){

                // VALIDATION COMPLIANCE
                if ( this.flow.typeCode === "account_type_company" ){

                    // COMPANY NAME
                    if ( this.newRegister.company.fullName != "" ){
                        var companyName = this.newRegister.company.fullName
                        companyName = companyName.trim().split(' ').length
                        
                        if ( companyName < 2 ){
                            this.errorForm.companyInvite.fullName = true
                        } else {
                            this.errorForm.companyInvite.fullName = false
                        }
                    } else {
                        this.errorForm.companyInvite.fullName = true
                    }


                    // COMPANY EMAIL
                    if ( this.newRegister.company.email === "" || !this.validateEmail.company.regex || !this.validateEmail.company.status ){
                        this.errorForm.companyInvite.email = true
                    } else {
                        this.errorForm.companyInvite.email = false
                    }


                    // COMPANY LANGUAGE
                    if ( this.newRegister.company.languageId === "" ){
                        this.errorForm.companyInvite.languageId = true
                    } else {
                        this.errorForm.companyInvite.languageId = false
                    }


                    // COMPANY COUNTRY
                    if ( this.newRegister.company.countryId === "" ){
                        this.errorForm.companyInvite.countryId = true
                    } else {
                        this.errorForm.companyInvite.countryId = false
                    }


                    // COMPANY PHONE
                    if ( this.validatePhone.company.val === "" ){
                        this.errorForm.companyInvite.phoneNumber = true
                    } else if ( this.validatePhone.company.val.length < this.selectedCountryDDICompany.phoneMask.length ) {
                        this.errorForm.companyInvite.phoneNumber = true
                    } else {
                        this.errorForm.companyInvite.phoneNumber = false
                    }

                    // COMPANY TAXNUMBER
                    if ( this.newRegister.company.taxNumber ==="" ){
                        this.errorForm.companyInvite.taxNumber = true
                    } else {
                        this.errorForm.companyInvite.taxNumber = false
                    }


                    // CKECK VALIDATION COMPLIANCE
                    if ( this.errorForm.companyInvite.fullName || this.errorForm.companyInvite.email || this.errorForm.companyInvite.languageId || this.errorForm.companyInvite.countryId || this.errorForm.companyInvite.phoneNumber || this.errorForm.companyInvite.taxNumber ){
                        window.location.href = "#!company"
                        this.errorForm.company = true
                    } else {
                        this.errorForm.company = false
                    }
                }



                
                // PERSON NAME
                if ( this.newRegister.person.fullName != "" ){
                    var personName = this.newRegister.person.fullName
                    personName = personName.trim().split(' ').length
                    
                    if ( personName < 2 ){
                        this.errorForm.personInvite.fullName = true
                    } else {
                        this.errorForm.personInvite.fullName = false
                    }
                } else {
                    this.errorForm.personInvite.fullName = true
                }


                // EMAIL
                if ( this.newRegister.person.email === "" || !this.validateEmail.person.regex || !this.validateEmail.person.status ){
                    this.errorForm.personInvite.email = true
                } else {
                    this.errorForm.personInvite.email = false
                }


                // LANGUAGE
                if ( this.newRegister.person.languageId === "" ){
                    this.errorForm.personInvite.languageId = true
                } else {
                    this.errorForm.personInvite.languageId = false
                }


                // COUNTRY
                if ( this.newRegister.person.countryId === "" ){
                    this.errorForm.personInvite.countryId = true
                } else {
                    this.errorForm.personInvite.countryId = false
                }


                // PHONE
                if ( this.validatePhone.person.val === "" ){
                    this.errorForm.personInvite.phoneNumber = true
                } else if ( this.validatePhone.person.val.length < this.selectedCountryDDI.phoneMask.length ) {
                    this.errorForm.personInvite.phoneNumber = true
                } else {
                    this.errorForm.personInvite.phoneNumber = false
                }


                // TAXNUMBER
                // if ( this.newRegister.person.taxNumber ==="" ){
                //     this.errorForm.personInvite.taxNumber = true
                // } else {
                //     this.errorForm.personInvite.taxNumber = false
                // }


                // ACCEPTS
                if ( !this.accept.terms ){
                    this.errorForm.acceptsInvite.acceptTerms = true
                } else{
                    this.errorForm.acceptsInvite.acceptTerms = false
                }
                
                if ( !this.accept.notify ){
                    this.errorForm.acceptsInvite.acceptNotify = true
                } else{
                    this.errorForm.acceptsInvite.acceptNotify = false
                }
                
                if ( !this.accept.gdpr ){
                    this.errorForm.acceptsInvite.acceptGdpr = true
                } else{
                    this.errorForm.acceptsInvite.acceptGdpr = false
                }

                if ( this.errorForm.acceptsInvite.acceptTerms || this.errorForm.acceptsInvite.acceptNotify || this.errorForm.acceptsInvite.acceptGdpr ){
                    this.errorForm.accepts = true
                } else {
                    this.errorForm.accepts = false
                }


                // CKECK VALIDATION COMPLIANCE
                if ( !this.errorForm.company && (this.errorForm.personInvite.fullName || this.errorForm.personInvite.email || this.errorForm.personInvite.languageId || this.errorForm.personInvite.countryId || this.errorForm.personInvite.phoneNumber) ){
                    window.location.href = "#!person"
                    this.errorForm.person = true
                } else {
                    this.errorForm.person = false
                }


                // CHECK HAS REFERRER
                if ( this.hasReferrer ){
                    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
                    
                    if (!uuidRegex.test(this.utm.referrerId)) {
                        this.errorForm.codReferrerId = true;
                    } else {
                        this.errorForm.codReferrerId = false;
                    }
                }


                // LAST CKECK
                if ( !this.errorForm.company && !this.errorForm.accepts && !this.errorForm.person ){
                    this.register()
                }
            },

            
            register(){
                this.load = true
                
                if ( this.flow.typeCode === "account_type_company" ){
                    let dataPhoneCompany = this.validatePhone.company.val
                    this.newRegister.company.phoneNumber = dataPhoneCompany.replace(/[^0-9]/g,'')
                }
                
                let dataPhonePerson = this.validatePhone.person.val
                this.newRegister.person.phoneNumber = dataPhonePerson.replace(/[^0-9]/g,'')


                if ( this.flow.typeCode === "account_type_person" ){
                    delete this.newRegister.company;
                }

                // URL POST
                if ( this.utm.referrerId ){
                    this.urlPost = `/api/v2/platform/account/register?referrer_account_id=${this.utm.referrerId}`
                } else {
                    this.urlPost = "/api/v2/platform/account/register"
                }
                

                apiPlatform.post(this.urlPost, this.newRegister)
                .then(response => {
                    this.registerId = response.data.id;
                    const languageRedirect = String(window.location.pathname).split("/")[1];
                    // window.location.href = `/${languageRedirect}/account/confirm-email-invite/${this.$route.params.registerId}`

                    if ( this.dataOrigin == "modal" ){
                        window.location.href = `/${languageRedirect}/account/register-success-modal`
                    } else{
                        window.location.href = `/${languageRedirect}/account/register-success`
                    }
                })
                .catch(error => {
                    console.log(error.response.data)

                    if ( error.response.data === "account_activate_email_already_exists" || error.response.data === "account_activate_phone_already_exists" ) {
                        this.errorsPost.newRegister = error.response.data
                    } else if ( error.response.data === "not_allowed_restricted_country_pep" ) {
                        this.errorsPost.country_pep = true
                    } else{
                        this.errorsPost.general = error.response.status

                        setTimeout(() => {
                            this.errorsPost.general = false
                        }, 4000);
                    }

                    console.log(this.errorsPost)

                    setTimeout(() => {
                        this.load = false
                    }, 500);
                })
            },
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                    this.orderLangs()
                    this.ordercountries()
                }
            }
        }
    }
</script>

<style src="@/assets/scss/_register.scss" lang="scss" scoped />